import workspaceQuery from 'graphql/queries/product/ProductGlobalAmendResultsWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/product/ProductGlobalAmendQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ProductGlobalAmendResult: EntityType = {
  type: 'ProductGlobalAmendResult',
  title: 'Product Global Amendment Results',
  formTitle: 'Product Global Amendment Result',
  workspaceUrl: '/Products/ProductGlobalAmendResultDetails/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  screenReference: 'PRODUCTS_GLOBAL_AMENDMENTS',
};

export default ProductGlobalAmendResult;
